module.exports = __webpack_public_path__ + "img/btn03.d9296d0f.svg";